// extracted by mini-css-extract-plugin
export var compactFilters = "_em-4";
export var detailImage = "_em-1";
export var dropdownContainer = "_em-2";
export var imageContainer = "_em-0";
export var selectedCard = "_em-3";